const state = {
  moves: {
    list: [],
    methods: [],
    effects: [],
    targets: [],
    damageClasses: [],
  }
}

const mutations = {
  MOVES_SET_LIST(state, list) {
    state.moves.list = list
  },
  MOVES_SET_METHODS(state, methods) {
    state.moves.methods = methods
  },
  MOVES_SET_EFFECTS(state, effects) {
    state.moves.effects = effects
  },
  MOVES_SET_TARGETS(state, targets) {
    state.moves.targets = targets
  },
  MOVES_SET_DAMAGE_CLASSES(state, damageClasses) {
    state.moves.damageClasses = damageClasses
  },
}

const actions = {
  setList: ({ commit }, list) => commit('MOVES_SET_LIST', list),
  setMethods: ({ commit }, methods) => commit('MOVES_SET_METHODS', methods),
  setEffects: ({ commit }, effects) => commit('MOVES_SET_EFFECTS', effects),
  setTargets: ({ commit }, targets) => commit('MOVES_SET_TARGETS', targets),
  setDamageClasses: ({ commit }, damageClasses) => commit('MOVES_SET_DAMAGE_CLASSES', damageClasses),
}

const getters = {
  list: state => state.moves.list,
  methods: state => state.moves.methods,
  effects: state => state.moves.effects,
  targets: state => state.moves.targets,
  damageClasses: state => state.moves.damageClasses,
}

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
}
